import styled, { keyframes } from "styled-components";

const slideIn = keyframes`
  from {
    opacity: 0;
    right: -100%;

  }
  to {
    opacity: 1;
    right: 0;

  }
`;

const slideOut = keyframes`
  from {
    opacity: 1;
    right: 0;

  }
  to {
    opacity: 0;
    right: -100%;

  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const blurIn = keyframes`
  from {
    backdrop-filter: blur(0px);

  }
  to {
    backdrop-filter: blur(3px);

  }
`;

const blurOut = keyframes`
  from {
    backdrop-filter: blur(3px);

  }
  to {
    backdrop-filter: blur(0px);

  }
`;
export const ModalBackground = styled.div`
  z-index: 10000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  background-color: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  animation: ${(props) => (props.$open ? blurIn : blurOut)} 0.3s ease-in-out;
  display: flex;
  justify-content: flex-end;
  transition: all 0.3s ease-in-out;
`;

export const ModalContainer = styled.div`
  z-index: 10000;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  transition: right 0.3s ease-in-out;

  display: flex;
  justify-content: ${(props) => (props.$center ? "center" : "flex-end")};
  align-items: center;
`;

export const ModalContainerSlide = styled.div`
  z-index: 10000;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  transition: right 0.3s ease-in-out;

  display: flex;
  justify-content: ${(props) => (props.$center ? "center" : "flex-end")};
  align-items: center;
  @media (max-width: 485px) {
    align-items: flex-start;
  }
`;

export const ModalContent = styled.div`
  position: relative;
  background-color: white;
  border-left: 3px solid #484888;
  border-top: 3px solid #484888;
  border-bottom: 3px solid #484888;
  border-radius: 30px 0px 0px 30px;
  display: flex;
  width: 450px;
  height: fit-content;
  gap: 30px;
  padding: 32px;
  flex-direction: column;
  justify-content: space-between;
  animation: ${(props) => (props.$open ? slideIn : slideOut)} 0.3s ease-in-out;

  flex-shrink: 0;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  @media (max-width: 485px) {
    width: 100% !important;
    border-radius: 0rem;
    border-left: none;
    height: fit-content !important;
  }
`;

export const ModalContentFade = styled.div`
  position: relative;

  border: 3px solid #484888;
  border-radius: 30px;
  background-color: white;
  display: flex;
  width: 450px;
  height: fit-content;
  gap: 30px;
  padding: 32px;
  flex-direction: column;
  justify-content: space-between;
  animation: ${(props) => (props.$open ? fadeIn : fadeOut)} 0.3s ease-in-out;
  flex-shrink: 0;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  @media (max-width: 485px) {
    width: 90% !important;
  }
`;
